import React from "react"

import { keyIssueItemRequest } from "../../actions/key-issue-actions"

import pageComponent from "../common/page-component-hoc"

import KeyIssueListWidgetContainer from "./key-issue-list/KeyIssueListWidgetContainer"
import KeyIssueFilterWidgetContainer from "./key-issue-filter/KeyIssueFilterWidgetContainer"
import KeyIssue from "./key-issue-item/KeyIssue"

const KeyIssuesComponent = ({ isFilterActive }) => (
    <div className="widgets-container clearfix row">
        <div
            className="col-xs-12 col-md-6 col-lg-5 col-xl-4 widget-list"
            id="keys-list"
        >
            {isFilterActive ? (
                <KeyIssueFilterWidgetContainer />
            ) : (
                <KeyIssueListWidgetContainer />
            )}
        </div>
        <KeyIssue />
    </div>
)

export default pageComponent("keyIssues", keyIssueItemRequest)(
    KeyIssuesComponent
)
